<script setup lang="ts">
import { RouterLink, useRouter } from "vue-router";

import { SearchRouteHelper } from "@/helpers";
import { useUserStore } from "@/stores";
import type { DictsysPhraseReference } from "@/types";

const props = defineProps<{
  text: string;
  textLanguage: string;
  references: DictsysPhraseReference[];
  wrapped?: boolean;
}>();

const userStore = useUserStore();

const searchRouteHelper = new SearchRouteHelper(useRouter(), userStore.userData);
</script>

<template>
  <span class="le-article-phrase-link"
    ><span v-if="props.wrapped">(</span
    ><span class="le-article-phrase-link__element" :lang="props.textLanguage">{{ props.text }}</span
    ><span v-for="(reference, referenceIndex) in props.references" :key="referenceIndex"
      ><RouterLink
        class="le-article-phrase-link__link"
        :to="searchRouteHelper.generateQuerySearchUrl(reference.link)"
        >{{ reference.text }}</RouterLink
      >
      <span
        v-if="referenceIndex < props.references.length - 1"
        class="le-article-phrase-link__element le-article-phrase-link__inner-element"
        >/</span
      ></span
    ><span v-if="props.wrapped">)</span></span
  >
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";
@import "@/assets/styles/dictsys-article";

.le-article-phrase-link {
  color: @colors[@neutrals][500];
  .dictsys-article-text();

  &__inner-element {
    margin-left: 8px;
  }

  &__element {
    margin-right: 8px;
  }

  &__link {
    .dictsys-article-link();
  }
}
</style>
